import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class OrderDetailService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/

  constructor(private http: Http) { }

	getOrderDetail(id) {
		return this.http
			.get(this.apiUrl + "order/v1/getbyid/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
		
	getAccountClientDetails(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomerbyprincipalcode/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAccountDivistionDetails(token, divisao, item, numero) {
		return this.http
			.get(this.apiUrl + "shippingdivision/v1/getshippingdivision/" +divisao + "/"+ item+"/"+numero, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getLogs(token, divisao, item, numero, sort, orderby, page) {

		 var filter = {
			OrdemDivisao: divisao,
			OrdemVendaItem: item,
			OrdemVendaNumero: numero
		};

		page = page * globalConst.paginationSkip;

		return this.http
			.post(this.apiUrl + "/logs/v1/getlogliberacao/?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page, filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getLogFlowDetails(token, divisao, item, numero, idSolicitante) {
		return this.http
			.get(this.apiUrl + "shippingdivision/v1/getshippingdivisionlogs/" + divisao + "/"+ item + "/" + numero + "/" + idSolicitante, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	changeOrderStatus(token, data) {
		return this.http
			.post(this.apiUrl + "/order/v1/postalterstatus", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	blockOrder(token, data) {
		return this.http
			.post(this.apiUrl + "/order/v1/postlistflowblock", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	approveOrder(token, data) {
		return this.http
			.post(this.apiUrl + "/order/v1/postflowapproval", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	releaseOrder(token, data) {
		return this.http
			.post(this.apiUrl + "/order/v1/postrequester", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

}



// WEBPACK FOOTER //
// ./src/app/order/service/order-detail/order-detail.service.ts